export default __webpack_public_path__ + "static/media/expressJS.3d55a114.svg";